import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  triageAnswers: [],
  allTriageAnswers: [],
  totalPages: 0,
  totalRecords: 0,
  triageAnswer: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_102: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_TriageAnswers(state, triageAnswers) {
    state.triageAnswers = triageAnswers.items;
    state.totalPages = triageAnswers.totalPages;
    state.totalRecords = triageAnswers?.totalRecords ?? 0;
  },
  SET_AllTriageAnswers(state, triageAnswers) {
    state.allTriageAnswers = triageAnswers;
  },
  SET_TriageAnswer(state, triageAnswer) {
    state.triageAnswer = triageAnswer;
  },
};
const actions = {
  errorTriageAnswer({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllTriageAnswers({ commit, dispatch, rootState }, triageQuestionId) {
    let url = '/TriageAnswers/All?TriageQuestionId=' + triageQuestionId;
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_AllTriageAnswers', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTriageAnswer', error);
      });
  },
  getAllTriageAnswersByMissionIdDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('Missions/TriageAnswers', {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllTriageAnswers', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTriageAnswer', error);
      });
  },
  addTriageAnswer({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/TriageAnswers', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTriageAnswer', error);
      });
  },
  getTriageAnswerByIdForGetQuestion({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/TriageAnswers/ById?triageAnswerId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_TriageAnswer', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTriageAnswer', error);
      });
  },
  getTriageAnswer({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/TriageAnswers/ById?triageAnswerId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_TriageAnswer', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTriageAnswer', error);
      });
  },
  editTriageAnswer({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/TriageAnswers/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTriageAnswer', error);
      });
  },
  deleteTriageAnswer({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/TriageAnswers/Remove?triageAnswerId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTriageAnswer', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
